import React from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { BaseReactComponent } from "../../utils/form";
import { API_LIMIT, isModuleExist, START_PAGE, SUPER_ADMIN } from "../../utils/Constant";
import { ComponentHeader } from "../common";
import { getSsoUserApi } from "./Api";
import { replaceHistory, userRoleType } from "../../utils/ReusableFunctions";
import { withRouter } from "../../utils/hoc/withRouter";
class SsoUser extends BaseReactComponent {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist("Sso", 'Web User');
    // const roleType = userRoleType() || SUPER_ADMIN;
    this.state = {
      access: AccesData,
      search: "",
      dummyData: [],
      searchResult: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      userLoginDetails: {}
    };
  }

  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getSsoUserApi(this);

    const getUserLoginDetails = () => {
      const userDetails = localStorage.getItem('finAdmin');
      if (userDetails) {
        this.setState({ userLoginDetails: JSON.parse(userDetails) })
      }
    };

    // Fetch user login details
    getUserLoginDetails();


  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevSearch = prevParams.get("search") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const search = params.get("search") || "";

    if (prevPage !== page || prevSearch !== search) {
      this.setState({ currentPage: page, search }, () => {
        this.props.getSsoUserApi(this);

      });
    }
  }


  clearSearch = () => {
    this.onChangeMethod({ search: "" })
  }

  onChangeMethod = (value) => {
    this.setState({ searchText: value.search, currentPage: START_PAGE }, () => {
      replaceHistory(this.props.history, START_PAGE, value.search)
    })
  }

  getDetailsUser = (rowData) => {
    // sessionStorage.setItem("detail", JSON.stringify(rowData))
    this.props.history({ pathname: `/sso/web-user/details/0/${rowData?.id}`, state: { "id": rowData?.id } });
  }





  render() {

    const { userList, totalPages, currentPage } = this.props.usersState;
    // console.log(this.props)
    return (
      <>

        <section className="request-section">
          <ComponentHeader
            title="Customers"
            isSearch={true}
            placeholder={"Search Customer"}
            onChangeMethod={this.onChangeMethod}
            clearSearch={() => this.clearSearch()}
          />
          {/* <CustomTab data={nav_obj} /> */}
          <div className="commom-table-wrapper">
            <CustomTable
              data={userList?.list || []}
              columns={[

                {
                  width: 200,
                  title: "Full Name",
                  dataIndex: "firstName",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "firstName") {
                      const firstName = rowData.firstName ?? "";
                      const lastName = rowData.lastName ?? "";
                      return `${firstName} ${lastName}`.trim();
                    }
                  },
                },
                {
                  width: 200,
                  title: "Email Id",
                  dataIndex: "emailAddress",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "emailAddress") {
                      return rowData.emailAddress || 'Na';
                    }
                  },
                },

                {
                  width: 250,
                  title: "Mobile Number",
                  dataIndex: "mobileNumber",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "mobileNumber") {
                      return rowData.mobileNumber || 'Na';
                    }
                  },
                },
                {
                  width: 250,
                  title: "Company Name",
                  dataIndex: "companyName",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "companyName") {
                      return rowData.companyName || 'Na';
                    }
                  },
                },
                {
                  width: 200,
                  title: "No of Events",
                  dataIndex: "noOfEvent",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "noOfEvent") {
                      return rowData.noOfEvent;
                    }
                  },
                },
                {
                  width: 350,
                  title: "Subscription Plan Name",
                  dataIndex: "premiumPlanName",
                  className: "name",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "premiumPlanName") {
                      return (
                        <>
                          {rowData?.premiumPlanName || 'NA'}
                          <br />
                          {rowData?.subPremiumPlanName || 'NA'}
                          <br />
                          {rowData?.subPremiumPlanVariation || 'NA'}
                        </>
                      );
                    }
                  },
                },
                {
                  width: 100,
                  title: "Liked",
                  dataIndex: "liked",
                  className: "liked",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "liked") {
                      return rowData?.liked;

                    }

                  },
                },
                {
                  width: 100,
                  title: "Shared",
                  dataIndex: "shared",
                  className: "shared",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "shared") {

                      return rowData?.shared;
                    }
                    return '0';
                  },
                },
                {
                  width: 150,
                  title: "Downloaded",
                  dataIndex: "downloaded",
                  className: "downloaded",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "downloaded") {

                      return rowData?.downloaded;
                    }

                  },
                },
                {
                  width: 150,
                  title: "Cobrand",
                  dataIndex: "cobrand",
                  className: "cobrand",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "cobrand") {
                      return rowData?.cobrand;

                    }

                  },
                },
                {
                  width: 100,
                  title: "Saved",
                  dataIndex: "saved",
                  className: "saved",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "saved") {
                      return rowData?.saved;

                    }

                  },
                },


                {
                  width: this.state.userLoginDetails?.user?.ssoPartner?.allowPartnerAdminUserDetails ? 300 : 0,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                    if (dataKey === "") {
                      return (
                        <>
                          <Button onClick={() => this.getDetailsUser(rowData)} className="primary-btn inter-medium f-s-14 lh-18">
                            View Detail
                          </Button>

                        </>

                      );
                    }
                  },
                },


              ]}
              message="No data found" // For Pagination
              history={this.props.history}
              location={this.props.location}
              total={totalPages}
              currentPage={currentPage}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}


const mapStateToProps = state => ({
  usersState: state.SsoContentEventState,
});
const mapDispatchToProps = {
  getSsoUserApi

};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SsoUser));
